<template>
    <footer class="bg-white">
        <ul class="flex items-center justify-between lg:container px-4 py-6 mx-auto text-sm md:px-6">
            <li>
                <div class="px-8">
                    <h3 class="font-bold text-gray-900">In short brief</h3>
                    <p class="py-4 text-gray-600 text-sm">
                        This is a simple NewsFeed web app for Sdui interview
                    </p>
                </div>
            </li>
            <li>
                Made with love by
                <a href="https://github.com/mtuchi/sdui" target="_blank" rel="noopener noreferrer"
                    class="font-bold">Mtuchi
                </a>
            </li>
        </ul>
    </footer>
</template>

<script>
export default {
    name: 'Footer',
}
</script>